import React, { CSSProperties } from "react";
import { generatePath } from "react-router-dom";
import { IProduct } from "../../../interfaces/product";
import Messages from "../../../languages/Messages";
import Path from "../../Path";

interface IProductNameView {
    product: IProduct | any;
    isHideSku?: boolean;
    isHideImage?: boolean;
    subContent?: any;
    subName?: any;
    className?: string;
    classNameLabel?: string;
    classNameContent?: string;
    classNameImage?: string;
    styleImage?: CSSProperties;
}

const ProductNameView = ({
    product,
    isHideSku,
    isHideImage = false,
    subContent = <div />,
    subName,
    className,
    classNameLabel,
    classNameContent,
    classNameImage,
    styleImage = {},
}: IProductNameView) => {
    const { thumbnail, SKU } = product;

    const getNameProduct = () => {
        /******
         * in case custom product, name not have specific languages => so display key: name
         */
        if (product?.isCustomProduct) {
            return <h5>{(product as any)?.name}</h5>;
        }
        return (
            <a
                className={`h5 ${classNameLabel}`}
                href={generatePath(Path.PRODUCT_DETAIL, {
                    productId: product?.id ?? "productId",
                })}
            >
                {(product as any)?.[Messages.getLanguage()]?.name ?? ""}
            </a>
        );
    };

    const renderImageProduct = () => {
        const urlDefault = "/images/placeholder.png";
        if (isHideImage) {
            return <div />;
        }
        return (
            <img
                src={thumbnail?.thumbnail ?? urlDefault}
                className={`image-square-small ${classNameImage}`}
                style={styleImage}
            />
        );
    };

    return (
        <div className={`d-flex ${className}`}>
            {renderImageProduct()}
            <div className={`flex-column ml-2 ${classNameContent}`}>
                <div className="d-flex">
                    <text className="d-flex flex-wrap align-items-center">
                        {getNameProduct()}
                        <div
                            hidden={!subName}
                            className="width-fit-content ml-1"
                        >
                            {subName && subName}
                        </div>
                    </text>
                </div>
                {!isHideSku && (
                    <small>
                        {Messages.sku}: {SKU}
                    </small>
                )}
                {subContent}
            </div>
        </div>
    );
};

export default ProductNameView;
